import React, { useId } from "react"

// Inline SVG area sparkline — no chart dependency. Renders a 30-point trend
// scaled to the viewBox; responsive via viewBox + width/height 100%.
export function RevenueTrendChart({ points }) {
  const gradientId = useId()

  if (!points || points.length < 2) return null

  const w = 600
  const h = 160
  const max = Math.max(...points)
  const min = Math.min(...points)
  const span = max - min || 1
  const dx = w / (points.length - 1)

  const coords = points.map((p, i) => {
    const x = i * dx
    const y = h - ((p - min) / span) * (h - 8) - 4
    return [x, y]
  })

  const line = coords.map(([x, y], i) => `${i === 0 ? "M" : "L"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ")
  const area = `${line} L${w},${h} L0,${h} Z`

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      preserveAspectRatio="none"
      className="h-40 w-full"
      role="img"
      aria-label="Revenue trend"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="rgb(16 185 129)" stopOpacity="0.25" />
          <stop offset="100%" stopColor="rgb(16 185 129)" stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={area} fill={`url(#${gradientId})`} />
      <path d={line} fill="none" stroke="rgb(16 185 129)" strokeWidth="2" vectorEffect="non-scaling-stroke" />
    </svg>
  )
}
